"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileMenuView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const app_2 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const __1 = require("../..");
const Panel = (0, app_1.styled)(ui_1.Stack) `
  position: absolute;
  top: calc(100% + 1px);
  height: calc(100vh - var(--nav-height));
  background: #ffffff;
  width: 100vw;
  padding: ${(theme) => `${theme.spacing.medium} ${theme.spacing.small}`};
  color: ${(theme) => theme.colors.secondary};
  overflow: auto !important;
  * {
    font-weight: 500;
    letter-spacing: 0.175rem;
  }
`;
const LoginWrap = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
`;
const LoginText = app_1.styled.span `
  font-size: 0.75rem;
  color: ${(theme) => theme.colors.secondary};
`;
const MainLabel = app_1.styled.span `
  font-size: 0.8125rem;
`;
const UserAvatar = (0, app_1.styled)(ui_1.Avatar) `
  background: ${(theme) => theme.colors.primary};
  > svg {
    height: 1rem !important;
    width: 1rem !important;
  }
`;
function MobileMenu({ links, menuLink: LinkComp, closeMenu }) {
    const { user } = (0, __1.useAuth)();
    const [, dispatch] = (0, __1.useUi)();
    const { params } = (0, __1.useSearchMeta)();
    const userPanelPath = (0, app_1.useContextPath)('ecommerce.userPanel');
    const signInPath = (0, app_1.useContextPath)('signIn');
    const avatarPath = user ? userPanelPath : signInPath;
    const scrollLockRef = (0, app_1.useScrollLock)();
    const closePanels = (0, react_1.useCallback)(() => dispatch('CLOSE_ALL_PANELS'), [dispatch]);
    return ((0, jsx_runtime_1.jsxs)(Panel, Object.assign({ kind: "vertical", divider: true, ref: scrollLockRef }, { children: [(0, jsx_runtime_1.jsx)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: links === null || links === void 0 ? void 0 : links.map((link) => {
                    var _a;
                    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(LinkComp, Object.assign({ onClick: closeMenu, css: (0, app_1.css) `
                @media ${app_1.notDesktop} {
                  display: block;
                }
              `, href: new app_2.Href(link.href, Object.assign(Object.assign({}, params), link.params)) }, { children: (0, jsx_runtime_1.jsx)(MainLabel, { children: link.label }) })), ((_a = link.subCategories) !== null && _a !== void 0 ? _a : []).map((subLink) => ((0, jsx_runtime_1.jsx)(LinkComp, Object.assign({ onClick: closeMenu, css: (0, app_1.css) `
                  @media ${app_1.notDesktop} {
                    display: block;
                    padding-left: ${(theme) => theme.spacing.extraSmall};
                  }
                `, href: subLink.href }, { children: (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: subLink.label })) }), subLink.id)))] }, link.id));
                }) })), (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: avatarPath, onClick: closePanels }, { children: (0, jsx_runtime_1.jsxs)(LoginWrap, { children: [(0, jsx_runtime_1.jsx)(UserAvatar, {}), (0, jsx_runtime_1.jsx)(LoginText, { children: user ? 'PANEL UŻYTKOWNIKA' : 'ZALOGUJ SIĘ' })] }) }))] })));
}
function MobileMenuView({ links, menuLink, }) {
    const [{ ecomMenuPanelOpen }, dispatch] = (0, __1.useUi)('ecomMenuPanelOpen');
    const closePanel = (0, react_1.useCallback)(() => dispatch('CLOSE_ECOM_MENU_PANEL'), [dispatch]);
    return ((0, jsx_runtime_1.jsx)(ui_1.Animation, Object.assign({ auto: "height" }, { children: ecomMenuPanelOpen && ((0, jsx_runtime_1.jsx)(MobileMenu, { links: links, menuLink: menuLink, closeMenu: closePanel })) })));
}
exports.MobileMenuView = MobileMenuView;
